import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subscription, timer, of } from "rxjs";
import { catchError, exhaustMap, tap } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { ProfileActions } from "../../core/store/profile";


@Injectable({ providedIn: 'root' })
export class TokenRefreshService {
    private readonly _authService = inject(AuthService);
    private readonly _store = inject(Store);

    private _subscription: Subscription | null = null;

    // refresh за 5 минут до конца
    private readonly _refreshOffsetMs = 5 * 60 * 1000;

    start(): void {
        // чтобы не плодить таймеры при повторных вызовах
        this.stop();

        const token = localStorage.getItem('token');
        const expiresAtRaw = localStorage.getItem('tokenExpiresAt');
        const expiresAt = expiresAtRaw ? Number(expiresAtRaw) : NaN;

        if (!token || !Number.isFinite(expiresAt)) {
            return;
        }

        const delayMs = Math.max(0, expiresAt - Date.now() - this._refreshOffsetMs);

        this._subscription = timer(delayMs).pipe(
            // не допускаем параллельных refresh, если внезапно start() вызовут несколько раз
            exhaustMap(() =>
                this._authService.refreshSession().pipe(
                    tap((res) => {
                        // обновляем токен + абсолютное время истечения
                        localStorage.setItem('token', res.sessionId);
                        const newExpiresAt = Date.now() + res.expiresIn * 1000;
                        localStorage.setItem('tokenExpiresAt', String(newExpiresAt));
                    }),
                    tap(() => {
                        // перепланируем следующий refresh на основе нового expiresAt
                        this.start();
                    }),
                    catchError((err) => {
                        // если refresh не удался — безопаснее разлогинить
                        this._store.dispatch(ProfileActions.logout());
                        return of(null);
                    })
                )
            )
        ).subscribe();
    }

    stop(): void {
        if (this._subscription) {
            this._subscription.unsubscribe();
            this._subscription = null;
        }
    }
}
